import { isMobile, toggleScrollLock } from './functions.js';
import { initAnimatedUnderlines } from './modules.js';

var $ = require("jquery");
require("jquery/package.json");

function menu_toggle() {
	const menu_toggle = document.querySelector('.menu-toggle');

    if( !menu_toggle ) return;

	const body = document.querySelectorAll('body');
	const mobileMenu = document.getElementById('primary-menu');
	const menuItems = mobileMenu ? mobileMenu.querySelectorAll('a, button') : [];
	const allElementsExceptMenu = document.querySelectorAll(
		'a:not(.b-primary-navigation a):not(.menu-toggle)'
	);

	let focusTimeout;
	let previouslyFocusedElement; // Store the element that had focus before menu opened

	// Initially set menu items as non-tabbable
	menuItems.forEach((item) => {
		item.setAttribute('tabindex', '-1');
	});

	// Function to close the menu
	function closeMenu() {
		body[0].classList.remove('toggled');
		menu_toggle.setAttribute('aria-expanded', 'false');

        console.log('dog');

		// Restore focus to previous element
		if (previouslyFocusedElement && previouslyFocusedElement !== document.body) {
			previouslyFocusedElement.focus();
		}
		previouslyFocusedElement = null;

		// Toggle scroll lock
		toggleScrollLock();

		// Set tab indices for menu items based on menu state
		menuItems.forEach((item) => {
			item.setAttribute('tabindex', '-1');
		});

		// Set tab indices for other elements based on menu state
		allElementsExceptMenu.forEach((element) => {
			element.setAttribute('tabindex', '0');
		});

		const siteBranding = document.querySelector('.b-primary-navigation .c-site-branding');
		if (siteBranding) {
			siteBranding.classList.remove('active');
		}
	}

	menu_toggle.addEventListener('click', (e) => {
		e.preventDefault();

		// Clear any pending focus timeout
		if (focusTimeout) {
			clearTimeout(focusTimeout);
			focusTimeout = null;
		}

		// Toggle menu state
		body[0].classList.toggle('toggled');

		// Check the actual state after toggle
		const isMenuOpen = body[0].classList.contains('toggled');

		// Store or restore focus based on menu state
		if (isMenuOpen) {
			// Menu is opening - store the currently focused element
			previouslyFocusedElement = document.activeElement;
		} else {
			// Menu is closing - handled by toggle logic above
			closeMenu();
			return;
		}

		// Update aria-expanded based on menu state
		menu_toggle.setAttribute('aria-expanded', isMenuOpen ? 'true' : 'false');

		// Set tab indices for menu items based on menu state
		menuItems.forEach((item) => {
			const newTabIndex = isMenuOpen ? '0' : '-1';
			item.setAttribute('tabindex', newTabIndex);
		});

		// Set tab indices for other elements based on menu state
		allElementsExceptMenu.forEach((element) => {
			const newTabIndex = isMenuOpen ? '-1' : '0';
			element.setAttribute('tabindex', newTabIndex);
		});

        const siteBranding = document.querySelector('.b-primary-navigation .c-site-branding');
		// Focus the first menu item when opening
		if (isMenuOpen) {
			focusTimeout = setTimeout(() => {
				if (menuItems.length > 0 && menuItems[0].getAttribute('tabindex') === '0') {
					menuItems[0].focus();
				}
			}, 200);
			// Add active class to site branding after menu animation completes
			if (siteBranding) {
                siteBranding.classList.add('active');
			}
		}

		// Toggle scroll lock with position preservation
		toggleScrollLock();

		menu_toggle.blur();
	});

	// // Close menu when clicking on a menu item
	// menuItems.forEach((item) => {
	// 	item.addEventListener('click', () => {
	// 		if (body[0].classList.contains('toggled')) {
	// 			closeMenu();
	// 		}
	// 	});
	// });

	// Close menu when clicking the overlay (body::before)
	document.addEventListener('click', (e) => {
		const isMenuOpen = body[0].classList.contains('toggled');
		const isClickOnMenu = e.target.closest('.c-primary-navigation');
		const isClickOnHamburger = e.target.closest('.c-hamburger');

		// Close menu if clicking outside of menu and hamburger, and menu is open
		if (isMenuOpen && !isClickOnMenu && !isClickOnHamburger) {
			closeMenu();
		}
	});
}

function dropdown_menu() {
	const nav = document.querySelector('.c-primary-navigation');
	const menuItems = document.querySelectorAll('.c-primary-navigation li');
	const allMenuItems = document.querySelectorAll('.c-primary-navigation > ul > li');
	const siteHeader = document.querySelector('.b-site-header');
	const body = document.body;

	if (!menuItems.length) return;

	// Close all dropdowns
	function closeAllDropdowns() {
		// Remove is-active from ALL items in navigation
		const allActiveItems = document.querySelectorAll('.c-primary-navigation .is-active');
		allActiveItems.forEach((item) => {
			item.classList.remove('is-active');
			const link = item.querySelector('a');
			if (link) {
				link.setAttribute('aria-expanded', 'false');
			}
		});
	}

	// Then set up dropdown-specific behavior
	menuItems.forEach((item) => {
		const link = Array.from(item.children).find(child => child.tagName === 'A');
		const dropdown = item.querySelector(':scope > .dropdown-menu');

		if (!link) return;
		if (!dropdown) return;

		// Desktop: Hover handling - add is-active on mouseenter
		link.addEventListener('mouseenter', () => {
			if (!isMobile()) {
				item.classList.add('is-active');
				link.setAttribute('aria-expanded', 'true');
			}
		});

		// Desktop: Remove is-active on mouseleave
		item.addEventListener('mouseleave', () => {
			if (!isMobile()) {
				item.classList.remove('is-active');
				link.setAttribute('aria-expanded', 'false');
			}
		});


		// Mobile/Click handling
		link.addEventListener('click', (e) => {
			// If clicking on .arrow, toggle the menu on mobile
			if (e.target.closest('.arrow')) {
				e.preventDefault();

				if (isMobile()) {
					if (item.classList.contains('is-active')) {
						// Close this dropdown
						item.classList.remove('is-active');
						link.setAttribute('aria-expanded', 'false');
					} else {
						// Open this dropdown and close others
						menuItems.forEach((otherItem) => {
							if (otherItem !== item) {
								otherItem.classList.remove('is-active');
								const otherLink = Array.from(otherItem.children).find(child => child.tagName === 'A');
								if (otherLink) {
									otherLink.setAttribute('aria-expanded', 'false');
								}
							}
						});
						item.classList.add('is-active');
						link.setAttribute('aria-expanded', 'true');
					}
				}
				return;
			}

			// If dropdown is already open, allow link to work
			if (item.classList.contains('is-active')) {
				// Check if there's an actual link to follow
				if (link.href && link.href !== '#') {
					return; // Allow default behavior
				} else {
					e.preventDefault();
					return;
				}
			}

			// If dropdown is closed, open it on click
			if (isMobile()) {
				e.preventDefault();
				// Close all other dropdowns except this one
				menuItems.forEach((otherItem) => {
					if (otherItem !== item) {
						otherItem.classList.remove('is-active');
						const otherLink = Array.from(otherItem.children).find(child => child.tagName === 'A');
						if (otherLink) {
							otherLink.setAttribute('aria-expanded', 'false');
						}
					}
				});
				item.classList.add('is-active');
				link.setAttribute('aria-expanded', 'true');
			}
		});

		// Handle submenu items
		const subItems = item.querySelectorAll('.sub-menu li.menu-item-has-children');
		subItems.forEach((subItem) => {
			const subLink = Array.from(subItem.children).find(child => child.tagName === 'A');
			const subMenu = subItem.querySelector(':scope > .sub-menu');

			if (isMobile()) {
				subLink.addEventListener('click', (e) => {
					// If clicking on .arrow, toggle the submenu on mobile
					if (e.target.closest('.arrow')) {
						e.preventDefault();

						if (subItem.classList.contains('is-active')) {
							// Close this submenu
							subItem.classList.remove('is-active');
							subLink.setAttribute('aria-expanded', 'false');
						} else {
							// Open this submenu and close siblings
							subItem.parentElement.querySelectorAll('li.menu-item-has-children').forEach((sibling) => {
								if (sibling !== subItem) {
									sibling.classList.remove('is-active');
									const siblingLink = sibling.querySelector(':scope > a');
									if (siblingLink) {
										siblingLink.setAttribute('aria-expanded', 'false');
									}
								}
							});
							subItem.classList.add('is-active');
							subLink.setAttribute('aria-expanded', 'true');
						}
						return;
					}

					if (subItem.classList.contains('is-active')) {
						if (subLink.href && subLink.href !== '#') {
							return;
						} else {
							e.preventDefault();
							return;
						}
					}

					if (isMobile()) {
						e.preventDefault();
						// Close siblings
						subItem.parentElement.querySelectorAll('li.menu-item-has-children').forEach((sibling) => {
							if (sibling !== subItem) {
								sibling.classList.remove('is-active');
								const siblingLink = sibling.querySelector(':scope > a');
								if (siblingLink) {
									siblingLink.setAttribute('aria-expanded', 'false');
								}
							}
						});

						subItem.classList.add('is-active');
						subLink.setAttribute('aria-expanded', 'true');
					}
				});
			}
		});
	});

	// Close dropdowns when leaving the entire site header on desktop
	if (siteHeader) {
		siteHeader.addEventListener('mouseleave', () => {
			if (!isMobile()) {
				closeAllDropdowns();
			}
		});
	}

	// Close dropdowns when clicking outside
	document.addEventListener('click', (e) => {
		const isClickInsideNav = e.target.closest('.c-primary-navigation');

		if (!isClickInsideNav && isMobile()) {
			closeAllDropdowns();
		}
	});

	// Handle escape key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAllDropdowns();
		}
	});

	// Set initial aria-expanded attributes
	menuItems.forEach((item) => {
		const link = Array.from(item.children).find(child => child.tagName === 'A');
		if (link) {
			link.setAttribute('aria-expanded', 'false');
		}
	});
}

dropdown_menu();

menu_toggle();
